import React from 'react'
import classes from './style.module.css'

import { strings } from '../../../../../../i18n'
import Icon from '../../../../../elements/Icon/Icon'
import CurrencyName from '../../../CurrencyName'

const Selector = (props) => {

    const {
        width,
        description,
        descriptionIcon,
        mainIcon,
        onClick,
        name,
        select,
        type
    } = props

    return (
        <div style={{ width: width }}
        >
            {description &&
                <div className={classes.text__wrapper}>
                    {descriptionIcon &&
                        <div>
                            <Icon icon={descriptionIcon} size={window.screen.width > 360 ? 16 : 13} color='#404040' />
                        </div>
                    }
                    <div className={classes.text} style={{ marginLeft: descriptionIcon ? 7 : 0 }} >
                        {description}
                    </div>
                </div>
            }
            <div className={classes.btn} onClick={onClick}>
                <div className={classes.content} >
                    {!select ?
                        <div>
                            {type === 'CRYPTO' ?
                                <Icon icon={mainIcon} color='#F7F7F7' size={24} />
                                :
                                type === 'FIAT' ?
                                    <Icon icon={mainIcon} color='#F7F7F7' size={24} />
                                    :
                                    type === 'PAYWAY' ?
                                        <Icon icon={mainIcon === 'MOBILE' ? 'MOBILESELECT' : mainIcon.toString().indexOf('VISA_MC') !== -1 ? 'VISAMC' : mainIcon} color='#F7F7F7' size={24} /> :
                                        mainIcon ?
                                            <Icon icon={mainIcon} color='#F7F7F7' size={24} /> :
                                            <div className={classes.select}>
                                                {strings('mobileExchanger.selectCurrency')}
                                            </div>
                            }
                        </div>
                        :
                        <div className={classes.select}>
                            {strings('mobileExchanger.selectCurrency')}
                        </div>
                    }
                    <div className={classes.content__text}>{CurrencyName[name]}</div>
                </div>
                <div className={classes.arrow}>
                    <Icon icon='ARROW_DOWN' color='#F7F7F7' size={24} />
                </div>
            </div>
        </div>
    )
}

export default Selector